
  import { computed, defineComponent } from 'vue';
  import { Colour } from '../../../helpers/colour';
  import './divider.scss';

  /**
   * Divider / horizontal rule
   * 
   * @example
   * <code>import TpxDivider from '@manifesto-tech/tpximpact-design-system/components/atoms/divider/divider.vue'</code>
   */
  export default defineComponent({
    name: 'TpxDivider',
    
    props: {
      /**
       * Specify the colour of the horizontal rule
       */
      colour: {
        type: String,
        default: Colour.Jet,
        validator: (value: Colour) => {
          return Object.values(Colour).includes(value);
        },
      },
    },

    data() {
      return {
        classes: computed(() => ({
          [`bg--${this.colour}`]: !!this.colour,
        })),
      };
    },
  });
